export const CONTENT_ITEMS = {
  PREDICTION: 'prediction',
  ABOUT_US: 'about_us',
  USER_ENTERING: 'user_entering',
  AFTER_USER_CHOOSE: 'after_user_choose'
} as const;

export type ContentItemsType = typeof CONTENT_ITEMS[keyof typeof CONTENT_ITEMS];
